module.exports = ReactRedux;


//////////////////
// WEBPACK FOOTER
// external "ReactRedux"
// module id = 10
// module chunks = 0